// Everything a user reads that carries data travels as a `Message { key, params }` (ARCH §2.7); the English
// catalogue and the renderer live in `packages/core/src/messages` (T-020). The binding this module held — the
// fallback context for sentences that carry no account data and `messageText`, which is `render` with that
// default — lives in core since T-369 (D-1246), so the phone renders through the same code instead of a
// hand-copied table; this module re-exports it under the names the routes have always used.
//
// A screen inside the shell passes the account's own context instead (`useMessages()` / `useShell()`), so
// money and dates are formatted in the account’s currency and zone (REQ-261). The route error boundary has
// no account — it runs when a route throws, possibly before one is loaded — which is what the fallback is for.

export { GENERIC_ERROR_TEXT, fallbackMessageContext, messageText } from '@sl/core';

/**
 * A banner's bold lead runs into the sentence after it on one line (w17 §3), so a catalogue sentence used
 * there ends in a full stop. Punctuation only — the words are never touched (T-048).
 */
export function asSentence(text: string): string {
  return /[.!?]$/.test(text.trim()) ? text : `${text}.`;
}
